import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Home } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center px-6 grid-bg">
      <div className="text-center">
        <div className="text-8xl font-bold text-white/10 select-none" style={{fontFamily:"'Cabinet Grotesk', sans-serif"}}>404</div>
        <h1 className="mt-4 text-3xl font-bold tracking-tight" style={{fontFamily:"'Cabinet Grotesk', sans-serif"}}>Page not found</h1>
        <p className="mt-3 text-zinc-400 max-w-sm mx-auto">The page you're looking for doesn't exist or has been moved.</p>
        <Button asChild className="mt-8 bg-indigo-600 hover:bg-indigo-700 glow-primary">
          <Link to="/"><Home size={15} className="mr-2"/>Back to Home</Link>
        </Button>
      </div>
    </div>
  );
}
